import React from 'react';
import { MiniButton } from "./style";
import raiseSuccessMessage from "../util/raiseSuccessMessage";
import { copyToClipboard } from '@applyboard/ui-utils';
import { CopyFillIcon } from '@applyboard/ui-icons';
var CopyButton = function CopyButton(props) {
  if (!props.label) {
    return null;
  }
  return /*#__PURE__*/React.createElement(MiniButton, {
    "data-cy": props.dataCy,
    "data-tip": props.tooltip,
    "aria-label": "Copy to clipboard",
    onClick: function onClick() {
      copyToClipboard(props.label).then(function (isSuccess) {
        if (isSuccess) {
          if (props.successMessage) raiseSuccessMessage(props.successMessage);
          if (typeof props.onCopy === 'function') {
            props.onCopy(props.label);
          }
        }
      });
    }
  }, /*#__PURE__*/React.createElement(CopyFillIcon, {
    size: "sm"
  }));
};
export default CopyButton;